import React, { Component } from 'react';
import * as $ from 'jquery';
import background from '../../images/ios-collage.png';
import brandLogo from '../../images/brand-logo-inverse-dark.png';
import location from '../../images/location.png';
import phone from '../../images/phone.png';
import smile from '../../images/smile.png';
import { translate } from 'react-i18next';
import { SCREEN_WIDTH } from '../../App.js';

class Vcontract extends Component {

  componentDidMount() {
    const { t } = this.props;
    $('#terms_check').click(function () {
        if ($(this).is(':checked')) {
            $('#accept_btn').removeAttr('disabled');
        } else {
            $('#accept_btn').attr('disabled', true);
        }
    });

    $('#contract_details').on('shown.bs.collapse', function() {
      $("#collapse_span").addClass('glyphicon-chevron-up').removeClass('glyphicon-chevron-down');
      $("#collapse_text").html(t('guest.vcontract.btn_contract_hide'));
    });

    $('#contract_details').on('hidden.bs.collapse', function() {
      $("#collapse_span").addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-up');
      $("#collapse_text").html(t('guest.vcontract.btn_contract_show'));
    });
  }

  handleTermsClick = () => {
    let contract = this.props.contract;
    window.open('/terms-of-service/'+contract.centro_razon_social,'popup','width=600,height=600');
    return false;
  }

  render() {
    const { t } = this.props;
    let contract = this.props.contract;
    return(
      <div>
        <div className="container-padding">

          <h2 className="text-primary text-center">{t('guest.vcontract.heading')}</h2>
          <br />
          <div className="panel panel-default">
            <div className="panel-heading row dark-background" role="button" data-toggle="collapse" href="#contract_details">
              <h4><span id="collapse_text">{t('guest.vcontract.btn_contract_show')}</span><span id="collapse_span" className="glyphicon glyphicon-chevron-down pull-right"></span></h4>
            </div>
          </div>

          <div id="contract_details" className="collapse">
            <div>
        
              <div className="row">
                <div className="col-sm-4">
                  <img alt="IOS OFFICES" width="200px" src={brandLogo} />
                </div>
                <div className="col-sm-8 text-right">
                  <b><span style={{fontSize: "20px"}}>{t('guest.vcontract.contract_details.title')}</span> <br /> {contract.folio}</b>
                </div>
              </div>

              <br />

              <div className="row dark-background text-center">{t('guest.vcontract.contract_details.subtitle_contact')}</div>
              <div className="row gray-border">
                <div className="col-sm-4">A) {t('guest.vcontract.contract_details.label_individual')}:</div>
                <div className="col-sm-5 text-center">{contract.razon_social}</div>
                <div className="col-sm-1">{t('guest.vcontract.contract_details.label_phone')}</div>
                <div className="col-sm-2 text-center">{contract.telefono}</div>
              </div>
              <div className="row gray-border">
                <div className="col-sm-4">B) {t('guest.vcontract.contract_details.label_representative')}:</div>
                <div className="col-sm-5 text-center">{contract.representante}</div>
                <div className="col-sm-1">{t('guest.vcontract.contract_details.label_tax')}</div>
                <div className="col-sm-2 text-center">{contract.rfc}</div>
              </div>
              <div className="row gray-border">
                <div className="col-sm-2">C) {t('guest.vcontract.contract_details.label_fiscal_adress')}:</div>
                <div className="col-sm-10 text-center">{contract.domicilio}</div>
              </div>
              <div className="row gray-border">
                <div className="col-sm-1">{t('guest.vcontract.contract_details.label_city')}:</div>
                <div className="col-sm-3 text-center">{contract.ciudad}</div>
                <div className="col-sm-1">{t('guest.vcontract.contract_details.label_state')}:</div>
                <div className="col-sm-2 text-center">{contract.estado}</div>
                <div className="col-sm-1" style={{paddingRight:"0"}}>{t('guest.vcontract.contract_details.label_zip')}</div>
                <div className="col-sm-1 text-center">{contract.cp}</div>
                <div className="col-sm-2">{t('guest.vcontract.contract_details.label_country')}:</div>
                <div className="col-sm-1 text-center">{contract.pais}</div>
              </div>
              <div className="row gray-border">
                <div className="col-sm-4">{t('guest.vcontract.contract_details.label_email')}:</div>
                <div className="col-sm-3 text-center">{contract.correo}</div>
                <div className="col-sm-2">D) {t('guest.vcontract.contract_details.label_nature')}:</div>
                <div className="col-sm-3 text-center">{contract.giro}</div>
              </div>

              <br />

              <div className="row dark-background text-center"> E) {t('guest.vcontract.contract_details.subtitle_room')}</div>
              <div className="row table-text-center">
                <table className="table table-condensed table-bordered">
                  <thead>
                    <tr>
                      <th>{t('guest.vcontract.contract_details.label_rooms')}</th>
                      <th>{t('guest.vcontract.contract_details.label_hours')}</th>
                      <th>Total (USD)</th>
                      <th>{t('guest.vcontract.contract_details.label_comments')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contract.salas && contract.salas.map((sala, index) =>
                      <tr key={index} className="gray-border">
                        <td>{sala.sala}</td>
                        <td>{sala.horas}</td>
                        <td>{sala.total}</td>
                        <td>{sala.comentarios || "- -"}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <br />

              <div className="row dark-background text-center"> F) {t('guest.vcontract.contract_details.subtitle_services')}</div>
              <div className="row table-text-center">
                <table className="table table-condensed table-bordered">
                  <thead>
                    <tr>
                      <th>{t('guest.vcontract.contract_details.label_description')}</th>
                      <th>{t('guest.vcontract.contract_details.label_quantity')}</th>
                      <th>{t('guest.vcontract.contract_details.label_price')}</th>
                      <th>Total (USD)</th>
                      <th>{t('guest.vcontract.contract_details.label_comments')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contract.servicios && contract.servicios.map((servicio, index) =>
                      <tr key={index} className="gray-border">
                        <td>{servicio.servicio}</td>
                        <td>{servicio.cantidad}</td>
                        <td>{servicio.precio}</td>
                        <td>{servicio.total}</td>
                        <td>{servicio.comentario || "- -"}</td>
                      </tr>
                    )}
                    {contract.servicios && contract.servicios.length === 0 && <tr className="gray-border"> <td colspan="5">- -</td></tr>}
                  </tbody>
                </table>
              </div>

              <br />
              
              <div className="row dark-background text-center"> {t('guest.vcontract.contract_details.subtitle_center')}</div>
              <div className="row gray-border no-padding">
                <div className="col-sm-1" style={{paddingLeft:"8px"}}>G) {t('guest.vcontract.contract_details.center')}:</div>
                <div className="col-sm-4 text-center">{contract.centro}</div>
                <div className="col-sm-1">H) {t('guest.vcontract.contract_details.label_adress')}:</div>
                <div className="col-sm-6 text-center">{contract.centro_direccion}</div>
              </div>
              <div className="row gray-border">
                <div className="col-sm-1">{t('guest.vcontract.contract_details.label_city')}:</div>
                <div className="col-sm-5 text-center">{contract.centro_ciudad}</div>
                <div className="col-sm-1">{t('guest.vcontract.contract_details.label_state')}:</div>
                <div className="col-sm-3 text-center">{contract.centro_estado}</div>
                <div className="col-sm-1" style={{paddingRight:"0"}}>{t('guest.vcontract.contract_details.label_zip')}</div>
                <div className="col-sm-1 text-center">{contract.centro_cp}</div>
              </div>

              <br />
              
              <div className="row gray-border" style={{borderTop: "thin solid dimgray"}}>
                <div className="col-sm-3 dark-background">J) Total (USD):</div>
                <div className="col-sm-1 text-center">{contract.total}</div>
                <div className="col-sm-8">{contract.total_letra}</div>
              </div>
              <div className="row gray-border">
                <div className="col-sm-3 dark-background">K) {t('guest.vcontract.contract_details.label_added_tax')} (16%) (USD):</div>
                <div className="col-sm-1 text-center">{contract.iva}</div>
                <div className="col-sm-8">{contract.iva_letra}</div>
              </div>
              <div className="row gray-border">
                <div className="col-sm-3 dark-background">L) Total ({t('guest.vcontract.contract_details.label_tax_included')}) (USD):</div>
                <div className="col-sm-1 text-center">{contract.totalIva}</div>
                <div className="col-sm-8">{contract.totalIva_letra}</div>
              </div>

              <br />

              <div className="row" style={{fontSize: "11px"}}>
                <div className="col-sm-4" style={{paddingRight: ($(window).width() >= SCREEN_WIDTH.SMALL) ? "25px" : "15px"}}>

                  <div className="row dark-background text-center"> {t('guest.vcontract.contract_details.subtitle_term')}: </div>
                  <div className="row gray-border">
                    <div className="col-sm-6">N) {t('guest.vcontract.contract_details.label_initial')}:</div>
                    <div className="col-sm-6 text-center">{contract.vigencia_fechaini}</div>
                  </div>
                  <div className="row gray-border">
                    <div className="col-sm-6">O) {t('guest.vcontract.contract_details.label_expiration')}:</div>
                    <div className="col-sm-6 text-center">{contract.vigencia_fechafin}</div>
                  </div>

                  <br />

                  <div className="row gray-border" style={{borderTop: "thin solid dimgray"}}>
                    <div className="col-sm-6 dark-background">{t('guest.vcontract.contract_details.label_term')}:</div>
                    <div className="col-sm-6 text-center">{contract.total_hrs}</div>
                  </div>

                  <br />

                </div>

                <div className="col-sm-8 no-padding" style={{paddingRight: "0px", paddingLeft: "0px"}}>

                  <table className="table table-condensed table-bordered table-text-center">
                  <thead>
                    <tr>
                      <th>{t('guest.vcontract.contract_details.label_data')}</th>
                      <th>{t('guest.vcontract.contract_details.label_pesos')}</th>
                      <th>{t('guest.vcontract.contract_details.label_dollars')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="gray-border">
                      <td className="table-text-left">{t('guest.vcontract.contract_details.label_beneficiary')}: </td>
                      <td>{contract.centro_beneficiario_peso}</td>
                      <td>{contract.centro_beneficiario_dolar}</td>
                    </tr>
                    <tr className="gray-border">
                      <td className="table-text-left">{t('guest.vcontract.contract_details.label_institution')}:</td>
                      <td>{contract.banco_peso}</td>
                      <td>{contract.banco_dolar}</td>
                    </tr>
                    <tr className="gray-border">
                      <td className="table-text-left">{t('guest.vcontract.contract_details.label_account')}:</td>
                      <td>{contract.cuenta_peso}</td>
                      <td>{contract.cuenta_dolar}</td>
                    </tr>
                    <tr className="gray-border">
                      <td className="table-text-left">{t('guest.vcontract.contract_details.label_reference')}:</td>
                      <td>{contract.clabe_peso}</td>
                      <td>{contract.clabe_dolar}</td>
                    </tr>
                    <tr className="gray-border">
                      <td className="table-text-left">{t('guest.vcontract.contract_details.label_branch')}:</td>
                      <td>{contract.sucursal_peso}</td>
                      <td>{contract.sucursal_dolar}</td>
                    </tr>
                  </tbody>
                </table>

                </div>
              </div>

              <br />
              
              <div className="row dark-background">
                <div className="col-sm-12">{t('guest.vcontract.contract_details.label_observations')}:</div>
              </div>
              <div className="row gray-border">
                <div className="col-sm-12">{contract.observaciones || '- -'}</div>
              </div>

              <br />
              
              <div className="row">
                <table className="table table-condensed table-bordered table-text-center">
                  <tbody>
                      <tr className="gray-border">
                        <th>{t('guest.vcontract.contract_details.label_user')}:</th>
                        <td style={{borderTop: "thin solid dimgray"}}>{contract.representante}</td>
                        <th rowSpan="2">{t('guest.vcontract.contract_details.label_date')}:</th>
                        <td rowSpan="2" style={{borderTop: "thin solid dimgray"}}>{contract.fecha}</td>
                      </tr>
                      <tr className="gray-border">
                        <th>IOS:</th>
                        <td className="text-center" >{contract.centro_representante}</td>
                      </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>

          <br />
          
          <form method="post" onSubmit={this.props.handleVcontractSubmit}>
            <div className="text-right">
              <input
                id="terms_check"
                type="checkbox"
                required={true}>
              </input>
              &nbsp;
              {t('guest.vcontract.terms_and_conditions1')}
              <a onClick={this.handleTermsClick}>{t('guest.vcontract.terms_and_conditions2')}</a>
              {t('guest.vcontract.terms_and_conditions3')}
              <br /><br />
              <button
                id="accept_btn"
                className="btn btn-lg btn-info"
                type="submit">
                <span>{t('guest.vcontract.btn_accept')}</span>
              </button>
            </div>
          </form>

        </div>
      </div>
    );
  }
}

export default translate('common')(Vcontract);



// WEBPACK FOOTER //
// ./src/guest/vcontract/Vcontract.js